import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { resumeSubscription } from '../../../actions/spaces/SubscriptionsActions';
import { IEntityAction } from './IEntityAction';

export const ResumeSubscriptionEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: 'subscription-resume',
  translateName: Messages.resumeSubscription_action,
  isVisible: (subscriptions: ISubscriptionInfo[]) => FeatureFlags.suspendSubscriptions && subscriptions.length === 1 && subscriptions[0].suspended,
  isClickable: () => true,
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => resumeSubscription(subscriptions[0])
};
